<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" lg="6">
              <v-select
                v-model="form.tipoDocumentoPersonaId"
                :items="tiposDocumentosPersona"
                item-text="nombre"
                item-value="id"
                label="Tipos Documentos Persona"
                outlined
                dense
                hide-details
                clearable></v-select>

              <small v-for="error in errores.tipoDocumentoPersonaId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="6">
              <v-select
                v-model="form.categoriaId"
                :items="categorias"
                item-text="nombre"
                item-value="id"
                label="Categorías"
                outlined
                dense
                hide-details
                clearable>
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.nombre }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      {{ item.unidadNegocio.nombre }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>

              <small v-for="error in errores.categoriaId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" :disabled="guardando" :loading="guardando" text @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../../mixins/modal-form.mixin';
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import TiposDocumentosPersonaService from '../../services/tipos-documentos-persona.service';
import CategoriasService from '../../services/categorias.service';
import { ACCIONES } from '../../utils/constantes';
import RequisitoDocumentalService from '../../services/requisitos-documentales.service';

export default {
  name: 'ModalFormularioRequisitosDocumentales',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    institucionId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    'form.categoriaId': function () {
      this.errores.categoriaId = [];
    },
    'form.tipoDocumentoPersonaId': function () {
      this.errores.tipoDocumentoPersonaId = [];
    },
  },
  data() {
    return {
      tiposDocumentosPersona: [],
      categorias: [],
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        institucionId: this.institucionId,
        institucion: null,
        categoriaId: null,
        categoria: null,
        tipoDocumentoPersonaId: null,
        tipoDocumentoPersona: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        institucionId: data.institucionId,
        institucion: data.institucion,
        categoriaId: data.categoriaId,
        categoria: data.categoria,
        tipoDocumentoPersonaId: data.tipoDocumentoPersonaId,
        tipoDocumentoPersona: data.tipoDocumentoPersona,
      };
    },
    abrir(accion, data = []) {
      Promise.all([this.obtenerTiposDocumentosPersona(), this.obtenerCategorias()]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    cerrar() {
      this.cerrarMixin();
    },
    async obtenerTiposDocumentosPersona() {
      await this.findAllMixin(
        TiposDocumentosPersonaService.findAll,
        null,
        'TIPOS DOCUMENTOS PERSONA',
        () => {
          this.tiposDocumentosPersona = [];
        },
        null,
        (datos) => {
          this.tiposDocumentosPersona = datos;
        },
        () => {
          this.tiposDocumentosPersona = [];
        },
      );
    },
    async obtenerCategorias() {
      await this.findAllMixin(
        CategoriasService.findAll,
        null,
        'CATEGORÍAS',
        () => {
          this.categorias = [];
        },
        null,
        (datos) => {
          this.categorias = datos;
        },
        () => {
          this.categorias = [];
        },
      );
    },
    async guardar() {
      if (this.guardando) {
        return;
      }

      const accion = this.form?.id ? ACCIONES.EDITAR : ACCIONES.REGISTRAR;
      const fnServicio = this.form?.id ? RequisitoDocumentalService.update : RequisitoDocumentalService.create;

      await this.saveMixin(
        accion,
        fnServicio,
        this.form,
        null,
        'REQUISITO DOCUMENTAL',
        () => {
          this.guardando = true;
          this.errores = [];
        },
        () => {
          this.guardando = false;
        },
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          if (typeof errores === 'object') {
            this.errores = errores;
          }
        },
      );
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>